module.exports = __webpack_public_path__ + "static/etecube-e90de674f6369a303478e05d09f9d572.png";